import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberOrDashes'
})
export class NumberOrDashesPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value !== undefined
      && value !== null
      && !isNaN(value)) {
      return value;
    }
    return '--';
  }

}
